import axiosInstance from './axiosConfig';

// Get all discussions
export const getAllDiscussions = async (page , limit) => {
  const response = await axiosInstance.get(`/discussions?page=${page}&per_page=${limit}`);
  return response.data;
};

// Create a new discussion
export const createDiscussion = async (payload) => {
  const response = await axiosInstance.post('/discussions', payload)
  return response.data;
};

// Add a comment to a discussion
export const addCommentToDiscussion = async (discussionId, content) => {
  const response = await axiosInstance.post(`/discussions/${discussionId}/comments`, {
    comment: { content },
  });
  return response.data;
};


export const likeDislikeReaction = async (discussionId, action) => {
  const response = await axiosInstance.post(`/discussions/${discussionId}/reaction`,{
    reaction_type: action
  });
  return response.data;
};